export default {
  api: process.env.NODE_ENV === 'production' ? '/ja' : '/ja',
  BASE_API: process.env.NODE_ENV === 'production' ? '/ja' : '/ja'
};
